import { FieldProps } from '@rjsf/core';

export const EnforceHiddenField = (_props: FieldProps) => null;
